import { render, staticRenderFns } from "./lazyblock_our_mission.vue?vue&type=template&id=4a7c44e8&scoped=true"
import script from "./lazyblock_our_mission.vue?vue&type=script&lang=js"
export * from "./lazyblock_our_mission.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_our_mission.vue?vue&type=style&index=0&id=4a7c44e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7c44e8",
  null
  
)

export default component.exports